// Portail public : tokens de partage + publication d'instantanés côté backend
// (les liens doivent rester lisibles depuis le téléphone du client).
import QRCode from 'qrcode';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'oliva.portail.tokens';

const lire = () => JSON.parse(localStorage.getItem(KEY) ?? '{}');
const ecrire = (v) => localStorage.setItem(KEY, JSON.stringify(v));

const token = () =>
  `${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

export function getToken(type, id) {
  const map = lire();
  const cle = `${type}:${id}`;
  if (!map[cle]) {
    map[cle] = token();
    ecrire(map);
  }
  return map[cle];
}

export function aToken(type, id) {
  return Boolean(lire()[`${type}:${id}`]);
}

// Tiers disposant déjà d'un QR permanent (à republier après chaque écriture).
export const tiersAvecPortail = () =>
  Object.keys(lire())
    .filter((k) => k.startsWith('compte:'))
    .map((k) => k.slice('compte:'.length));

// Lien PERMANENT du tiers : un seul QR par contact, jamais régénéré.
export const lienCompte = (tiersId) => lienPortail('compte', tiersId);

export const lienPortail = (type, id) =>
  `${window.location.origin}/portail/${type === 'tracabilite' ? 'tracabilite' : type === 'lot' ? 'lot' : 'compte'}/${getToken(type, id)}`;

export async function publier(type, id, payload) {
  const tok = getToken(type, id);
  try {
    await fetch(`${API}/portail/publier`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: tok, type, payload }),
    });
  } catch {
    toast.error('Portail indisponible : le lien QR ne sera pas à jour.');
  }
  return lienPortail(type, id);
}

export async function lirePortail(tok) {
  const res = await fetch(`${API}/portail/${tok}`);
  if (!res.ok) return null;
  return res.json();
}

export async function qrDataUrl(url) {
  return QRCode.toDataURL(url, { width: 320, margin: 1, color: { dark: '#0f172a', light: '#ffffff' } });
}
